import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
// eslint-disable-next-line prettier/prettier
import type { RoleOptionsType } from '@/api/types/response/RoleType'
import type { UserRolePayloadType } from '@/api/types/request/UserRolePayloadType'

/**
 * @property string apiEnd /api/adjustment/role
 */
export default class RoleApi extends AbstractApi {
  options(): Promise<RoleOptionsType> {
    return httpClient.get(this.apiEnd)
  }

  update(payload: UserRolePayloadType[]): Promise<unknown> {
    return httpClient.put(this.apiEnd, payload)
  }
}
